import { render, staticRenderFns } from "./NoteFiche.vue?vue&type=template&id=08cd62e2&"
import script from "./NoteFiche.vue?vue&type=script&lang=js&"
export * from "./NoteFiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports